import { render, staticRenderFns } from "./LmHtmlContentBuilderUi.vue?vue&type=template&id=52e561ce&"
import script from "./LmHtmlContentBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmHtmlContentBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports